import { createSlice } from "@reduxjs/toolkit";

export const shopPageSlice = createSlice({
    name: 'shopPage',
    initialState: {
        sort: { value: 'featured', label: 'Sort: Featured'},
        products: [],
        categories: [],
        activeCategoryFilter: 'All',
        collections: [],
        activeCollectionFilter: 'All',
        cart: []
    },
    reducers: {
        setSort: (state, action) => {
            return {
                ...state,
                sort: action.payload
            }
        },
        setProducts: (state, action) => {
            return {
                ...state,
                products: action.payload
            }
        },
        setCategories: (state, action) => {
            return {
                ...state,
                categories: action.payload
            }
        },
        setActiveCategoryFilter: (state, action) => {
            return {
                ...state,
                activeCategoryFilter: action.payload
            }
        },
        setCollections: (state, action) => {
            return {
                ...state,
                collections: action.payload
            }
        },
        setActiveCollectionFilter: (state, action) => {
            return {
                ...state,
                activeCollectionFilter: action.payload
            }
        },
        addCartItem: (state, action) => {
            return {
                ...state,
                cart: [
                    ...state.cart,
                    action.payload
                ]
            }
        },
        changeQuantity: (state, action) => {
            const cartItemToUpdate = state.cart.find(item => item.id === action.payload.id);
            cartItemToUpdate.quantity = Number.parseInt(action.payload.quantity);
        },
        removeCartItem: (state, action) => {
            const newCart = state.cart.filter(item => item.id !== action.payload)
            return {
                ...state,
                cart: newCart
            }
        },
        clearCart: (state, action) => {
            return {
                ...state,
                cart: []
            }
        }
    }
})

export const selectSort = (state) => state.shopPage.sort;
export const selectProducts = (state) => state.shopPage.products;
export const selectCategories = (state) => state.shopPage.categories;
export const selectActiveCategoryFilter = (state) => state.shopPage.activeCategoryFilter;
export const selectCollections = (state) => state.shopPage.collections;
export const selectActiveCollectionFilter = (state) => state.shopPage.activeCollectionFilter;
export const selectCart = (state) => state.shopPage.cart;

export const {
    setSort,
    setProducts,
    setCategories,
    setActiveCategoryFilter,
    setCollections,
    setActiveCollectionFilter,
    addCartItem,
    changeQuantity,
    removeCartItem,
    clearCart
} = shopPageSlice.actions;

export default shopPageSlice.reducer;